import { render, staticRenderFns } from "./MetricsLayout.vue?vue&type=template&id=184ab9ab&scoped=true"
import script from "./MetricsLayout.vue?vue&type=script&lang=js"
export * from "./MetricsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ab9ab",
  null
  
)

export default component.exports